import React, { Fragment } from 'react';
import cn from 'classnames';
import Svg from '../../common/components/Svg';

const CustomerBasketDialogInner = ({
  lineItemsGroups,
  visible,
  loading,
  emptyText = 'The customer has no items in their basket.',
}) => {
  if (!visible) return null;

  if (loading) {
    return <div className={cn('line-items-group', '-loading')}>Loading...</div>;
  } else if (
    !lineItemsGroups ||
    lineItemsGroups.every(group => !group.line_items || group.line_items.length === 0)
  ) {
    // No supplier groups, or only groups left empty by removed items.
    return <div className={cn('line-items-group', '-empty')}>{emptyText}</div>;
  } else {
    return (
      <div className="line-items-groups">
        {lineItemsGroups.map((lineItemsGroup, index) => (
          <div className={'line-items-group'} key={index}>
            <div className={'line-items'}>
              {lineItemsGroup.line_items.map((lineItem, index) => (
                <div className={'line-item'} key={index}>
                  <div className={'line-item_image'}>
                    <a>
                      <img alt="" src={lineItem.variant.preview_images_urls[0]} />
                    </a>
                    {!lineItem.variant.in_stock &&
                      lineItem.variant.can_checkout_through_mbr && (
                        <div className="moodboard-small-product_label -out-of-stock">
                          <Svg icon="icon-cart" />
                        </div>
                      )}
                  </div>
                  <div className={'line-item_name'}>
                    <a href={lineItem.variant.link} target="_blank" rel="noopener noreferrer">
                      {lineItem.variant.name}
                    </a>
                    <div className={'line-item_sku'}>{lineItem.variant.sku}</div>
                  </div>
                  <div className={'line-item_price-quantity'}>
                    <div className={'line-item_price'}>{lineItem.price}</div>
                    <div className={'line-item_quantity'}>
                      <span>x</span>
                      {lineItem.quantity}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className={'line-items-group_supplier'}>
              {lineItemsGroup.supplier ? lineItemsGroup.supplier.name : 'n/a'}
            </div>
          </div>
        ))}
      </div>
    );
  }
};

export default CustomerBasketDialogInner;



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/components/CustomerBasketDialogInner.js